var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"block":_vm.block,"tile":_vm.tile,"text":_vm.text,"fab":_vm.fab,"outlined":_vm.outlined,"icon":_vm.icon,"rounded":_vm.rounded,"disabled":_vm.disabled,"title":_vm.title,"to":_vm.to},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }